import React from 'react';
import { useThemeClasses } from '../../lib/themes/utils';

interface TextAreaProps {
    label: string;
    id: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    subLabel?: string;
    rows?: number;
    disabled?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({ label, id, value, onChange, placeholder = '', subLabel, rows = 2, disabled = false }) => {
    const theme = useThemeClasses();
    
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e);
    };

    return (
        <div className="mb-4">
            <label 
                htmlFor={id} 
                className={`block mb-2 ${theme.typography.body} font-medium transition-colors ${theme.animations.duration}`}
            >
                {label}
            </label>
            {subLabel && (
                <p className={`text-sm ${theme.text.neutralLight} mb-2 transition-colors ${theme.animations.duration}`}>
                    {subLabel}
                </p>
            )}
            <div className="relative group">
                <textarea
                    id={id}
                    name={id}
                    value={value}
                    onChange={handleChange}
                    rows={rows}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={`
                        w-full
                        ${theme.inputs.default}
                        ${disabled 
                            ? 'bg-neutral-100 cursor-not-allowed opacity-50' 
                            : 'hover:border-primary-300 transition-all ' + theme.animations.duration
                        }
                        placeholder:text-neutral-400
                        ${theme.typography.body}
                        resize-y
                        min-h-[100px]
                    `}
                />
                <div className={`absolute inset-0 -z-10 bg-gradient-to-r from-primary-400 to-secondary-400 ${theme.radius.medium} opacity-0 blur-xl group-focus-within:opacity-20 transition-opacity ${theme.animations.duration}`}></div>
            </div>
        </div>
    );
};

export default TextArea;
